export const ShipmentPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'shipments.shipment.list-view',
    UPDATE: 'shipments.shipment.list-update',
    DELETE: 'shipments.shipment.list-delete',
  },
});
